import React from "react";
import "../css/policy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container">
      <h1>Privacy Policy</h1>
      <p>At H&H Fashion, your privacy is important to us. This policy explains how we collect, use, and protect your information when you interact with us via WhatsApp.</p>
      <section>
        <h2>1. Information We Collect</h2>
        <p>We may collect the following details:</p>
        <ul>
          <li>Name</li>
          <li>Mobile number</li>
          <li>Delivery address</li>
          <li>Payment details (transaction reference only, not card/UPI credentials)</li>
          <li>Order and communication history</li>
        </ul>
      </section>

      <section>

        <h2>2. How We Use Your Information</h2>
        <p>Your information is used to:</p>
        <ul>
          <li>Process and deliver your orders</li>
          <li>Communicate order updates and support</li>
          <li>Improve our products and services</li>
          <li>Share offers or updates (only if you opt in)</li>
        </ul>
      </section>  
      <section>
          <h2>3. Information Sharing</h2>
          <ul>
            <li>We do not sell or rent your personal information.</li>
            <li>Information is shared only with trusted third parties (courier, payment providers) strictly for order fulfilment.</li>
          </ul>
      </section>

      <section>
          <h2>4. Data Protection</h2>
           <ul>
            <li>We take reasonable security measures to protect your information.</li>
            <li>Access to customer data is limited to authorized persons only.</li>
          </ul>
      </section>

      <section>
          <h2>5. WhatsApp Communication</h2>
          <ul>
            <li>By messaging us, you consent to receive order-related messages via WhatsApp.</li>
            <li>Promotional messages will be sent only with your consent.</li>
            <li>You may opt out anytime by messaging <b>“STOP”</b>.</li>
          </ul>
      </section>

      <section>
          <h2>6. Data Retention</h2>
          <ul>
            <li>Customer information is retained only as long as necessary for business and legal purposes.</li>
            <li>You may request deletion of your data by contacting us.</li>
          </ul>
      </section>

      <section>
          <h2>7. Third-Party Services</h2>
          <ul>
            <li>Payments and deliveries may involve third-party services.</li>
            <li>We are not responsible for the privacy practices of these external platforms.</li>
          </ul>
      </section>

      <section>
          <h2>8. Children’s Privacy</h2>
          <ul>
            <li>Our services are not intended for individuals under 18 years of age.</li>
          </ul>
      </section>

      <section>
          <h2>9. Policy Updates</h2>
          <ul>
            <li>H&H Fashion may update this policy from time to time.</li>
            <li>Continued use of our WhatsApp services implies acceptance of updated policies.</li>
          </ul>
    </section>

    </div>
  );
};

export default PrivacyPolicy;
